// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"30":"781d2332","356":"4271a012"}[chunkId] + ".chunk.js";
};